import type { ComponentMeta } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { ActionsBlock } from "@circle-react-shared/BuilderUI/constants/BlockCategories";
import { borderRadius } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/borderRadius";
import { margin } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/margin";
import { padding } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/padding";
import { sizing } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/sizing";
import {
  ContentProp,
  CornersProp,
  DesignProp,
  GeneralProp,
  MarginsProp,
  PaddingsProp,
  SizingProp,
} from "@circle-react-shared/BuilderUI/constants/PropCategories";
import { defaultStyles } from "./defaultStyles";

export const meta: ComponentMeta = {
  name: "Form",
  nameI18n: "builder_ui.block_type.form",
  version: 1,
  category: [ActionsBlock],
  props: {
    form_id: {
      name: "Form",
      nameI18n: "builder_ui.form_block.form_id",
      type: "form-select",
      prop: "other",
      category: [ContentProp],
    },
    background_color: {
      name: "Background opacity & color",
      nameI18n: "builder_ui.prop_type.styles.background_color",
      type: "color",
      prop: "other",
      defaultValue: defaultStyles.backgroundColor,
      category: [DesignProp, GeneralProp],
    },
    styles: {
      name: "Styles",
      nameI18n: "builder_ui.prop_type.styles.title",
      category: [DesignProp],
      prop: "styles",
      type: "styles",
      attributes: {
        sizing: {
          ...sizing,
          defaultValue: defaultStyles.sizing,
          category: [DesignProp, SizingProp],
        },
        padding: {
          ...padding,
          defaultValue: defaultStyles.padding,
          category: [DesignProp, PaddingsProp],
        },
        margin: {
          ...margin,
          defaultValue: defaultStyles.margin,
          category: [DesignProp, MarginsProp],
        },
        borderRadius: {
          ...borderRadius,
          defaultValue: defaultStyles.borderRadius,
          category: [DesignProp, CornersProp],
        },
      },
    },
  },
};
